import React, { useState, useEffect, useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const GroupHealthFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. Is group health insurance considered part of employee compensation and expenses?",
      answer: (
        <>
          <span style={{ color: "#F37435", fontWeight: "700" }}>Yes</span>, group health insurance is considered part of employee expenses and is included in the Cost to Company (CTC). Employers usually pay part of the insurance cost, which is a valuable benefit for employees. This makes health insurance an important part of an employee's overall pay and benefits package. Employees might also pay a portion of the insurance through their paycheck, often using pre-tax money, which helps save on taxes. For employers, the cost of providing this insurance is a business expense and can help attract and keep good employees.
        </>
      )
    },
    {
      question: "Q2. What happens to my group health insurance if I leave my job?",
      answer: (
        <>
          "If you leave your job, you can typically continue your group health insurance for a limited time through <span style={{ color: "#F37435", fontWeight: "700" }}>COBRA</span>, where you'll pay the full premium yourself. Alternatively, you may qualify for a <span style={{ color: "#F37435", fontWeight: "700" }}>special enrollment period</span> to sign up for a new plan through the Health Insurance Marketplace or join a spouse's plan if available."
        </>
      )
    },

    {
      question: "Q3. Is health checkup necessary before taking group health insurance for employees?",
      answer: (
        <>
          Health checkups before taking group health insurance for employees are <span style={{ color: "#F37435", fontWeight: "700" }}>generally not mandatory. </span> However, insurers may request them to assess overall health risks and determine premium rates. Employers may also use checkups to promote employee health awareness and potentially lower future healthcare costs.
        </>
      )
    },
    {
      question: "Q4. What happens when you have a pre existing disease?",
      answer: (
        <>
          When you have a pre-existing disease and are seeking health insurance coverage, here's what typically happens
          <br></br> <span style={{ color: "#F37435", fontWeight: "700" }}>1.Disclosure:</span> You are required to disclose any pre-existing conditions when applying for health insurance. A pre-existing condition is a health issue you already have before applying for the insurance policy.
          <br></br> <span style={{ color: "#F37435", fontWeight: "700" }}>2.Coverage Consideration: </span>Insurance companies may consider pre-existing conditions differently:
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>3.Exclusion: </span>Some insurers may exclude coverage for treatments related to pre-existing conditions for a specific waiting period, typically the first few years of the policy.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>4.Premium Loading: </span>In some cases, insurers may increase your premium to cover the higher risk associated with pre-existing conditions.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>5.Full Coverage: </span>Certain policies may offer full coverage for pre-existing conditions after a waiting period or under specific conditions.
        </>
      )


    },
    {
      question: "Q5. What is the number of claims allowed over a year?",
      answer: (
        <>
          The number of claims allowed over a year can vary widely depending on the specific group health insurance policy and the terms negotiated between the employer and the insurance provider.<span style={{ color: "#F37435", fontWeight: "700" }}>Typically, there isn't a strict limit on the number of claims that can be made in a year.</span> Instead, policies often specify coverage limits per claim or aggregate limits over a policy period. It's important for employers and employees to review their policy documents to understand any specific limits or conditions related to claims under their group health insurance plan.
        </>
      )

    },
    {
      question: "Q6. What is a cashless claim and how does it work?",
      answer: (
        <>
          <>
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li>
                <span style={{ color: "#F37435", fontWeight: "700" }}>Choose Network Hospital:</span>
                <span style={{ color: "#000" }}> Select a hospital that is part of your health insurance provider's network.</span>
              </li>
              <li>
                <span style={{ color: "#F37435", fontWeight: "700" }}>Inform Hospital:</span>
                <span style={{ color: "#000" }}> Inform the hospital about your intention to make a cashless claim and provide your health insurance details.</span>
              </li>
              <li>
                <span style={{ color: "#F37435", fontWeight: "700" }}>Fill Pre-authorization Form:</span>
                <span style={{ color: "#000" }}> Fill out and submit a pre-authorization form provided by the hospital.</span>
              </li>
              <li>
                <span style={{ color: "#F37435", fontWeight: "700" }}>Insurance Verification:</span>
                <span style={{ color: "#000" }}> The hospital will verify your insurance coverage and submit a request to your insurance company for approval.</span>
              </li>
              <li>
                <span style={{ color: "#F37435", fontWeight: "700" }}>Approval Process:</span>
                <span style={{ color: "#000" }}> The insurance company reviews the request for cashless treatment. Once approved, the insurer sends an authorization letter directly to the hospital confirming coverage.</span>
              </li>
            </ul>
          </>

        </>

      )

    },
    {
      question: "Q7. Who is eligible for group health insurance?",
      answer: (
        <>
          Eligibility for group health insurance typically includes <span style={{ color: "#F37435", fontWeight: "700" }}>full-time employees, part-time employees </span> in some cases, and sometimes contractors or consultants working for the organization. Depending on the employer's policy. It's important to review the specific eligibility criteria outlined by your employer or benefits administrator to determine who qualifies for coverage.
        </>
      )

    },
    {
      question: "Q8. What are the tax benefits of group health insurance?",
      answer:
        (
          <>
            Group health insurance offers several tax benefits for both employers and employees:

            <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>1.Tax Deductions for Employers:</span>
            Business Expense: Premiums paid by employers for group health insurance are typically tax-deductible as a business expense, reducing taxable income.
            Employee Contributions: Employers can also deduct contributions made by employees towards their health insurance premiums.

            <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>2.Pre-Tax Contributions for Employees:</span>
            Salary Deduction: Many employers offer employees the option to pay their share of health insurance premiums using pre-tax income, which lowers taxable income and reduces the amount of income tax owed.

          </>
        )
    },

  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

  const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);




  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  //   const handleFaqClick = (index) => {
  //     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
  //   };
  const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div >
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
          // style={styles.scroll}

          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top" />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },



  span: {
    display: 'block'
  }

};



export default GroupHealthFAQ;